import { render, staticRenderFns } from "./CollectionPoolModal.vue?vue&type=template&id=02ef342e&"
import script from "./CollectionPoolModal.vue?vue&type=script&lang=js&"
export * from "./CollectionPoolModal.vue?vue&type=script&lang=js&"
import style0 from "./CollectionPoolModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports